// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__3hoG6","title":"card_title__ODTrX","inActive":"card_inActive__1VNoq"};